/**
 * Renders a data-age stamp: `08:42` for data read today, `9 Aug 08:42`
 * otherwise.
 *
 * The date earns its space only once the data isn't from today — a bare
 * time would then read as "this morning".
 */
export function formatDataAsOf(isoTimestamp: string): string {
  const readAt = new Date(isoTimestamp);
  const time = readAt.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });

  if (readAt.toDateString() === new Date().toDateString()) return time;

  const date = readAt.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short"
  });
  return `${date} ${time}`;
}
